import { Spinner } from '@vkontakte/vkui';
import { CSSTransition } from '@dui/motion';
import { LOADING_DELAY_MS } from '../../contexts';
import { CrushLogo } from '../CrushLogo';
import styles from './LoadingSpinner.module.css';

interface LoadingSpinnerProps {
  isLoading: boolean;
}

export function LoadingSpinner(props: LoadingSpinnerProps) {
  const { isLoading } = props;

  const classNames = {
    willEnter: styles['loading-willEnter'],
    entering: styles['loading-entering'],
    entered: '',
    willExit: '',
    exiting: styles['loading-exiting'],
    exited: styles['loading-exited'],
  };

  return (
    <CSSTransition
      on={isLoading}
      duration={LOADING_DELAY_MS}
      className={styles.root}
      classNames={classNames}
      style={{ '--transition-duration': `${LOADING_DELAY_MS}ms` } as React.CSSProperties}
    >
      <div className={styles.wrapper}>
        <CrushLogo width={295} height={155} />
        <Spinner size="xl" className={styles.spinner} />
      </div>
    </CSSTransition>
  );
}
